import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ThemeEditorComponent } from "@app/components/catalog-editor/theme-editor.component";

@Component({
  imports: [CommonModule, ThemeEditorComponent],
  standalone: true,
  templateUrl: "./theme-editor-panel.component.html",
  styles: [],
})
export class ThemeEditorPanelComponent implements AfterViewInit {
  @ViewChild(ThemeEditorComponent) themeEditorComponent: ThemeEditorComponent;
  _branding: string;
  _style: string;

  ngAfterViewInit(): void {
    window.addEventListener("message", (event) => {
      console.log(event.data);
      switch (event.data.type) {
        case "set-branding":
          console.log(
            "ThemeEditorPanelComponent set branding",
            event.data.branding
          );
          this.branding = event.data.properties;
          break;
        case "set-style":
          console.log("ThemeEditorPanelComponent set style", event.data.style);
          this.style = event.data.properties;
          break;
        case "ui-theme-item-action":
          const page = event.data.page;
          const item = event.data.item;
          console.log(
            "ThemeEditorPanelComponent ui-theme-item-action",
            page,
            item
          );
          this.themeEditorComponent.show(page, item);
          break;
      }
    });

    window.parent.postMessage(
      {
        type: "theme-editor-panel-ready",
      },
      "*"
    );
  }

  set branding(branding: string) {
    this._branding = branding;
    window.parent.postMessage(
      {
        type: "update-branding",
        branding,
      },
      "*"
    );
  }

  get branding(): string {
    return this._branding;
  }

  set style(style: string) {
    this._style = style;
    window.parent.postMessage(
      {
        type: "update-style",
        style,
      },
      "*"
    );
  }

  get style(): string {
    return this._style;
  }
}
